<template>
    <main class="stats">
        <section class="list-banner">
            <div class="overlay"></div>
            <h1 class="banner-title">Statistics</h1>
        </section>
        <SubMenu parent-route-name="stats" />
        <LoadingScreen v-if="!loaded" message="Loading statistics…" />
        <section v-else class="max-width-container">
            <ul class="highlight-boxes">
                <li>{{ stats.trips }} trips</li>
                <li>{{ stats.days }} days</li>
                <li>{{ stats.nights }} nights</li>
                <li>{{ stats.places }} places</li>
                <li>{{ stats.countries }} countries</li>
                <li>{{ stats.plane_rides }} plane rides</li>
            </ul>
            <ul class="stats-buttons">
                <li class="button yoy">
                    <span class="icon material-symbols-outlined">history</span>
                    <span>Year over year</span>
                    <router-link to="/stats/yoy" class="fill-space" />
                </li>
                <li class="button countries">
                    <span class="icon material-symbols-outlined">flag</span>
                    <span>Countries</span>
                    <router-link to="/stats/countries" class="fill-space" />
                </li>
                <li class="button places">
                    <span class="icon material-symbols-outlined">map</span>
                    <span>Places</span>
                    <router-link to="/stats/places" class="fill-space" />
                </li>
                <li class="button trips">
                    <span class="icon material-symbols-outlined">luggage</span>
                    <span>Trips</span>
                    <router-link to="/stats/trips" class="fill-space" />
                </li>
                <li class="button bucket-lists">
                    <span class="icon material-symbols-outlined">
                        checklist
                    </span>
                    <span>Bucket lists</span>
                    <router-link to="/stats/bucket-lists" class="fill-space" />
                </li>
                <li class="button transport">
                    <span class="icon material-symbols-outlined">
                        connecting_airports
                    </span>
                    <span>Transportation</span>
                    <router-link to="/stats/transport" class="fill-space" />
                </li>
                <li class="button companions">
                    <span class="icon material-symbols-outlined">group</span>
                    <span>Companions</span>
                    <router-link to="/stats/companions" class="fill-space" />
                </li>
                <li class="button outlined tbd">
                    <span class="icon material-symbols-outlined">payments</span>
                    <span>Spending</span>
                </li>
                <li class="button outlined tbd">
                    <span class="icon material-symbols-outlined">
                        inbox_customize
                    </span>
                    <span>Custom</span>
                </li>
            </ul>
        </section>
    </main>
</template>
<script>
import { fetch } from "js/lib/server.js";
import LoadingScreen from "js/components/common/LoadingScreen";

export default {
    components: { LoadingScreen },
    data() {
        return {
            loaded: false,
            stats: {
                countries: "N/A",
                places: "N/A",
                plane_rides: "N/A",
                nights: "N/A",
                days: "N/A",
                trips: "N/A",
                expenses: "N/A",
            },
        };
    },
    mounted() {
        fetch("/api/stats")
            .then((response) => {
                this.stats = response.data.summary;
            })
            .finally(() => {
                this.loaded = true;
            });
    },
};
</script>
